export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const SEND_OTP_REQUEST = "SEND_OTP_REQUEST";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAIL = "SEND_OTP_FAIL";

export const UPDATE_USER_DETAILS_REQUEST = "SEND_OTP_REQUEST";
export const UPDATE_USER_DETAILS_SUCCESS = "UPDATE_USER_DETAILS_SUCCESS";
export const UPDATE_USER_DETAILS_FAIL = "UPDATE_USER_DETAILS_FAIL";

export const CREATE_SELLER_ACCOUNT_REQUEST = "CREATE_SELLER_ACCOUNT_REQUEST";
export const CREATE_SELLER_ACCOUNT_SUCCESS = "CREATE_SELLER_ACCOUNT_SUCCESS";
export const CREATE_SELLER_ACCOUNT_FAIL = "CREATE_SELLER_ACCOUNT_FAIL";

export const CREATE_SELLER_ACCOUNT_LOGIN_REQUEST =
  "CREATE_SELLER_ACCOUNT_LOGIN_REQUEST";
export const CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS =
  "CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS";
export const CREATE_SELLER_ACCOUNT_LOGIN_FAIL =
  "CREATE_SELLER_ACCOUNT_LOGIN_FAIL";

export const CREATE_TAX_REGISTRATION_REQUEST =
  "CREATE_TAX_REGISTRATION_REQUEST";
export const CREATE_TAX_REGISTRATION_SUCCESS =
  "CREATE_TAX_REGISTRATION_SUCCESS";
export const CREATE_TAX_REGISTRATION_FAIL = "CREATE_TAX_REGISTRATION_FAIL";

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
